export default __webpack_public_path__ + "static/media/mahin-arafath-demo2.0048b30f.png";